import { http, HttpResponse, delay } from 'msw';

import { signupResponse } from '../data/signupData';

export const signupHandlers = [
  http.post('*/v3/signup', async () => {
    await delay();
    return HttpResponse.json(signupResponse, { status: 200 });
  }),
];
